import { cn } from '@/lib/utils'
import { LoadingSpinner } from './spinner'

function Skeleton({
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn(
                'animate-pulse rounded-md bg-muted border border-border',
                className,
            )}
            {...props}
        />
    )
}

/** Skeleton content with a spinner overlaid on top, so the loading state has both shape and unambiguous motion. */
function SkeletonWithSpinner({
    className,
    children,
}: {
    className?: string
    children: React.ReactNode
}) {
    return (
        <div className={cn('relative', className)}>
            {children}
            <div className="absolute inset-0 flex items-center justify-center">
                <LoadingSpinner />
            </div>
        </div>
    )
}

export { Skeleton, SkeletonWithSpinner }
